module.exports = __webpack_public_path__ + "static/media/share_mail.d0f97b7d.svg";